import { ReactElement, useEffect } from 'react';
import { SiteListCard } from '@components/lms/siteListWrapper/components/siteListCard/siteListCard';
import { useInfiniteScroll } from '@components/common';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useSiteListRxDb } from '@services/hooks/lms/siteList/useSiteListRxDb';
import { useSiteListFilterStore } from '@store/lms/siteListFilterStore';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';

export const ConversionSiteList = (): ReactElement => {
	const { fetchMore, isFetching, result } = useSiteListRxDb('Competition');
	const { updateFilter, resetFilter } = useSiteListFilterStore();

	useEffect(() => {
		// Set filters for conversion sites: competition sites that are not converted
		updateFilter({
			convertStatus: false,
		});

		return (): void => {
			resetFilter();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useInfiniteScroll(() => {
		fetchMore();
	});

	return (
		<Wrapper isLoaderVisible={isFetching && result.length === 0} isError={null}>
			<div className="common-list-card">
				<ul className="row">
					{result.length > 0 ? (
						result.map((site) => <SiteListCard key={site._data.id} site={site._data} isContractorSite={false} />)
					) : (
						<NoDataFound message="No Conversion Sites Found!" />
					)}
				</ul>
			</div>
		</Wrapper>
	);
};
